import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem, Modal, Box, Grid,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../styles/MyStyles";
import {GetAssetLookupMenuItemsByType} from "../../logic/LookupHelper";
import {CreateDataUpdateTicket} from "../../logic/TicketHelper";

const WalletRequestPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showRedirectModal, setShowRedirectModal] = useState(false);

    const [request, setRequest] = useState({
        assetId: '',
        address: '',
        isMultisig: false
    });

    useEffect(() => {
    }, []);

    const validateForm = () => {
        let newErrors = {};

        if (request.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (!request.address.trim()) {
            newErrors.address = 'Address is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            await CreateDataUpdateTicket(2, request);

            setShowRedirectModal(true);

        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };
    const handleCloseRedirectModal = (redirect) => {
        if (redirect) {
            navigate('/tickets');
        } else {
            handleGoBack()
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                New Wallet Request
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Send request
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={request.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetAssetLookupMenuItemsByType(1)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Address</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="address"
                                label="Address"
                                value={request.address}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Multisig</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="isMultisig"
                                label="Multisig"
                                select
                                value={request.isMultisig}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                            >
                                <MenuItem value={false}>No</MenuItem>
                                <MenuItem value={true}>Yes</MenuItem>
                            </TextField>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {showRedirectModal && (<Modal open={showRedirectModal} onClose={() => handleCloseRedirectModal(true)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        This action creates a new Ticket, the status of which you can see in the Tickets section.
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={12}>
                            <StyledButtonOrange onClick={() => handleCloseRedirectModal(true)}>
                                Ok
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </Container>
    );
};

export default WalletRequestPage;
